import { PackageCheck } from 'lucide-react';
import { Button, cn } from '@eombor/ui';
import { t } from '../../../shared/i18n/index.js';

export interface AcceptBarProps {
  /** Qabul qilishga tayyor talabnomalar soni. 0 bo'lsa panel chizilmaydi. */
  count: number;
  onOpen: () => void;
}

/**
 * QABUL QILISH paneli — pastki navigatsiya USTIDA.
 *
 * Nega yopishqoq panel, ro'yxatdagi oddiy tugma emas: mahsulotni olib
 * kelishgan payt odam telefonni qo'lida ushlab turadi va ro'yxatni
 * aylantirib, kerakli qatorni qidirishga vaqti yo'q. Amal doim bosh
 * barmoq ostida bo'lishi kerak.
 *
 * Panel FAQAT qabul qilinadigan talabnoma bo'lganda chiziladi. Doim
 * turgan, ko'pincha bo'sh panel ekran pastini bekorga egallardi.
 *
 * Joylashuvi: `--size-tabbar` (60px) + xavfsiz zona. Ikkalasi ham SHART —
 * biri bo'lmasa panel iPhone dagi pastki chiziq ostida yoki navigatsiya
 * tugmalari ustida qolib ketadi.
 */
export const AcceptBar = ({ count, onOpen }: AcceptBarProps) => {
  if (count === 0) return null;

  return (
    <div
      className={cn(
        // `sticky-bar` — sahifaning harakatlar paneli: kontentdan
        // yuqorida, karkasdan (pastki navigatsiya qatoridan) pastda.
        'fixed inset-x-0 z-[var(--z-sticky-bar)] px-3 pb-2',
        'bottom-[calc(var(--size-tabbar)_+_env(safe-area-inset-bottom))]',
        'motion-slide-in',
      )}
    >
      <Button
        variant="accent"
        className="w-full justify-between"
        // Son NOMGA qo'shiladi: doiradagi raqam faqat ko'z uchun, ekran
        // o'qigich uni alohida element sifatida umuman eshitmaydi.
        aria-label={t('accept.actionWithCount', { count })}
        onClick={onOpen}
      >
        <span className="flex items-center gap-2">
          <PackageCheck size={18} aria-hidden />
          {t('accept.action')}
        </span>
        {/* Son tugmaning O'Z rangida chiziladi: `Badge` bu yerda o'zining
            oq foni bilan tugmadan «kesib olingan» bo'lib ko'rinardi. */}
        <span
          aria-hidden
          className={cn(
            'tabular inline-flex min-w-6 items-center justify-center',
            'rounded-[var(--radius-pill)] bg-accent-contrast/20 px-2 py-0.5 text-xs font-semibold',
          )}
        >
          {count}
        </span>
      </Button>
    </div>
  );
};
